import { Devices, Spacings } from '@styles'

const { NavigationWrapper } = require('@base')
const { default: styled } = require('styled-components')

export const AdminManageLogisticsNavigationWrapper = styled(NavigationWrapper)`
	display: flex;
	align-items: center;
`

export const SearchWrapper = styled.div`
	padding-left: ${Spacings.SPACING_4B};
	margin-left: auto;
`

export const PsuedoWrapper = styled.div`
	position: sticky;
	bottom: 0;
	z-index: 1;
	background: ${({ theme }) => theme.palette.background.searchgrey};
	border-top: 1px solid ${({ theme }) => theme.palette.background.searchgrey};

	@media ${Devices.tablet} {
		margin: 0 -${Spacings.SPACING_4B};
	}
`

export const ButtonsWrapper = styled.div`
	display: flex;
	margin: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
`

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100%;
	min-width: 100%;
`
